// DATAVIB site config
// =====================================================
// WhatsApp numarası — buradaki "90XXXXXXXXXX" değerini
// kendi numaranızla değiştirin (uluslararası format,
// + işareti olmadan, örn: 905551234567)
// =====================================================
const WHATSAPP_PHONE = "905524653416";
const WHATSAPP_TEXT = "Merhaba DATAVIB, teklif almak istiyorum.";

export const SITE = {
  brand: "DATAVIB",
  tagline: "Makine Bakım Teknolojileri",
  phone: "+90 552 465 34 16",
  phoneHref: "tel:+905524653416",
  email: "info@datavib.com",
  emailHref: "mailto:info@datavib.com",
  whatsappPhone: WHATSAPP_PHONE,
  whatsapp: `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(WHATSAPP_TEXT)}`,
  address: "Rumeli Mah. Emirgan Cad. No:25/A Çorlu - TEKİRDAĞ",
  social: {
    linkedin: "#",
    instagram: "#",
  },
};

export const NAV = [
  { id: "anasayfa", label: "Ana Sayfa" },
  { id: "hizmetler", label: "Hizmetler" },
  { id: "surec", label: "Süreç" },
  { id: "referanslar", label: "Referanslar" },
  { id: "hakkimizda", label: "Hakkımızda" },
  { id: "iletisim", label: "İletişim" },
];

export const CITIES = [
  "İstanbul", "Tekirdağ", "Kocaeli", "Sakarya", "Bursa", "Ankara", "İzmir",
  "Eskişehir", "Konya", "Gaziantep", "Adana", "Mersin", "Kayseri", "Manisa",
  "Çanakkale", "Edirne", "Kırklareli", "Diğer",
];
